import React from 'react';
import './App.css';
import MailboxList from './MailboxList';
import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      mobile: 0,
      tablet: 640,
      sm: 640,
      laptop: 1024,
      md: 1024,
      desktop: 1200,
      lg: 1200,
      xl: 1536,
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <Attachment /> */}
      <MailboxList />
    </ThemeProvider>
  );
}

export default App;